module.exports = __webpack_public_path__ + "img/architect.907632d7.png";